import React from 'react';

/**
 * Animated Notification Indicator Component
 * Displays a pulsing indicator
 * 
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @param {number} props.size - Size in pixels (default: 25)
 * @param {string} props.color - Color hex code (default: #D9322E)
 * 
 */
export default function NotificationIndicator({ 
  className = '', 
  size = 25,
  color = '#D9322E'
}) {
  const containerStyle = {
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <div className={`notification-indicator ${className}`} style={containerStyle}>
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
        <defs>
          <filter 
            id={`notification-filter-${color.replace('#', '')}`}
            width="24.532" 
            height="24.532" 
            x="0" 
            y="0" 
            colorInterpolationFilters="sRGB" 
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur result="effect1_foregroundBlur_97_35" stdDeviation="2"/>
          </filter>
        </defs>
        <g filter={`url(#notification-filter-${color.replace('#', '')})`}>
          <circle 
            className="notification-indicator__outer-circle" 
            cx="12.266" 
            cy="12.266" 
            r="8.266" 
            fill={color} 
            fillOpacity=".2"
          />
        </g>
        <circle 
          className="notification-indicator__middle-circle" 
          cx="12.266" 
          cy="12.266" 
          r="5.199" 
          fill={color} 
          fillOpacity=".14"
        />
        <circle 
          className="notification-indicator__inner-circle" 
          cx="12.266" 
          cy="12.266" 
          r="2.688" 
          fill={color}
        />
      </svg>
    </div>
  );
}

